"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var PanelBody = function PanelBody(_ref) {
  var children = _ref.children,
      collapsible = _ref.collapsible,
      isOpen = _ref.isOpen,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)({
      'panel-body': true,
      'panel-body--collapsible': collapsible,
      'panel-body--collapse': collapsible && !isOpen,
      'panel-body--expand': isOpen,
      'panel-body--disabled': disabled
    }, customClass)
  }, children);
};

var _default = PanelBody;
exports.default = _default;